export default "__VITE_ASSET__CqozpVRR__"